(() => {
  'use strict';
  if (window.__gnwPersonalizationV5) return;
  window.__gnwPersonalizationV5 = true;
  const selector = '[data-gnw-personalization-v5]';
  const messages = () => window.gnwV5Strings || {};
  // Page-memory only: keep entries during high-variant form replacement.
  // Never store personal information in localStorage, cookies or analytics.
  const values = new Map();
  const remember = field => {
    const entry = values.get(field.dataset.productId) || new Map();
    field.querySelectorAll('input:not([type="hidden"]), textarea').forEach(input => {
      if (input.name) entry.set(input.name, input.value);
    });
    values.set(field.dataset.productId, entry);
  };
  const updateCount = field => {
    const input = field.querySelector('[data-gnw-personalization-text]');
    const count = field.querySelector('[data-gnw-char-counter]');
    if (input && count) count.textContent = `${input.value.length} / ${input.maxLength} ${messages().characters || 'Zeichen'}`;
  };
  const setMode = (field, options) => {
    field.hidden = false;
    field.disabled = false;
    field.querySelectorAll('[data-gnw-required]').forEach(input => {
      input.required = input.dataset.gnwRequired === 'true';
      input.setAttribute('aria-required', String(input.required));
    });
  };
  const init = (root = document) => {
    const fields = [...root.querySelectorAll(selector)];
    if (root.matches && root.matches(selector)) fields.unshift(root);
    fields.forEach(field => {
      if (field.dataset.gnwV5Ready) return;
      field.dataset.gnwV5Ready = 'true';
      const stored = values.get(field.dataset.productId);
      if (stored) field.querySelectorAll('input:not([type="hidden"]), textarea').forEach(input => {
        if (stored.has(input.name) && !input.value) input.value = stored.get(input.name);
      });
      updateCount(field);
      field.addEventListener('change', () => remember(field));
      try { setMode(field, JSON.parse(field.dataset.selectedOptions || '[]')); } catch (_) { setMode(field, []); }
      field.addEventListener('input', event => {
        const input = event.target;
        if (input.setCustomValidity) input.setCustomValidity('');
        input.removeAttribute('aria-invalid');
        const error = field.querySelector('[data-gnw-field-error]');
        if (error) error.hidden = true;
        remember(field);
        updateCount(field);
      });
    });
  };
  // Shared field validation is handled by gnw-order-fields.js.
  document.addEventListener('variant:change', event => {
    const variant = event.detail && event.detail.variant;
    if (!variant) return;
    document.querySelectorAll(selector).forEach(field => {
      const form = field.closest('form');
      const master = form && form.querySelector('[name="id"]');
      const ownsVariant = master && (master.tagName === 'SELECT'
        ? [...master.options].some(option => String(option.value) === String(variant.id))
        : String(master.value) === String(variant.id));
      if (ownsVariant) setMode(field, variant.options || [variant.option1, variant.option2, variant.option3]);
    });
  });
  const start = () => {
    init();
    // High-variant hot reload replaces forms. Initialize only newly added fields.
    new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(node => {
        if (node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))) init(node);
      }));
    }).observe(document.getElementById('MainContent') || document.body, {childList:true, subtree:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('quickview:loaded', () => init());
})();
